<template>
    
    <!-- Product List Edit Dialog -->
    <v-dialog v-model="isProductInfoEdit" width="600px" @click:outside="$emit('update:is-product-info-edit',false)">
      <v-card>
        <v-card-text>
          <div class="flex">
            <div class="w-full h-auto relative">
              <div ref="dropZoneRef" class="cursor-pointer" @click="() => openFile()">
                <div class="d-flex flex-column justify-center align-center gap-y-2 pa-2 drop-zone rounded">
                  <v-btn outlined color="secondary" class="rounded" size="30">
                    <v-icon size="24">{{ icons.mdiTrayArrowUp }}</v-icon>
                  </v-btn>
                  <span class="text-h6">Click to upload your Product Info File here.</span>
                </div>
                <div class="drop-zone" v-if="productFiles.length > 0">
                  <v-list-item
                    v-for="(item, index) in productFiles"
                    :key="index"
                    @click.stop
                  >
                    <v-list-item-title>{{ item.name }}</v-list-item-title>
                    <v-list-item-subtitle>{{ item.type }}</v-list-item-subtitle>
                    <template v-slot:append>
                      <v-list-item-action class="align-end">
                        <v-btn @click.stop="productFiles.splice(index, 1)">X</v-btn>
                      </v-list-item-action>
                    </template>
                  </v-list-item>
                </div>
              </div>
            </div>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text outlined class="mr-2" @click="cancelProductInfo">Cancel</v-btn>
          <v-btn color="primary" outlined :loading="loadProductData" @click="uploadProductInfo">Upload</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
import { ref, watch} from '@vue/composition-api'
import { mdiTrayArrowUp } from '@mdi/js'
import useProduct from '../useProduct'

export default {
    props: {
      isProductInfoEdit: {
        type: Boolean,
        required: true
      }
    },
    setup(props, {emit}) {
        
        const productFiles = ref([])

        const {
          loadProductData,

          addBulkProductsInfo
        } = useProduct()


        const uploadProductInfo = async () => {
          if (productFiles.value.length > 0){
            const resp = await addBulkProductsInfo(productFiles.value[0])
            console.log(resp)
          }

        }

        const cancelProductInfo = () => {
          productFiles.value = []
          emit('update:is-product-info-edit', false)
        }

        const openFile = () => {
            let input = document.createElement('input');
            input.type = 'file';
            input.accept = 'text/csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel'
            input.onchange = _ => {
                // you can use this method to get file and perform respective operations
                productFiles.value = Array.from(input.files);
                console.log(productFiles.value);

            };
            input.click();
        }

        return {
          openFile,
          productFiles,
          loadProductData,

          uploadProductInfo,
          cancelProductInfo,

          icons: {
            mdiTrayArrowUp
          }
        }
    },
}
</script>